module.exports = __webpack_public_path__ + "media/images/city/098-lonja-of-zaragoza-ddf2101d5f1550f7c02081950425ab51.svg";